import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { transparentize } from 'polished';
import { Theme } from 'styles/ThemeTyping';

interface Props {
  text: string;
  className?: string;
}

function EditDisabledNotice({ text, className }: Props) {
  const classes = useStyles();
  return <div className={className ? className : classes.root}>{text}</div>;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    color: theme.palette.secondary.main,
    border: `1px solid ${transparentize(0.88, theme.palette.secondary.main)}`,
    backgroundColor: transparentize(0.96, theme.palette.secondary.main),
    margin: 0,
    marginBottom: theme.spacing(3),
    padding: theme.spacing(0.5),
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    borderRadius: theme.spacing(0.5),
  },
}));

export default EditDisabledNotice;
